import React from "react";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { bgColor , borderColor } from "../styled";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export const options = {
  responsive: true,
  plugins: {
    legend: {
      position: "bottom",
    },
  },
};
const bgc = ["rgba(255, 99, 132, 0.5)",
              "rgba(54, 162, 235, 0.5)",
              "rgba(255, 206, 86, 0.5)",
              "rgba(75, 192, 192, 0.5)",
              "rgba(153, 102, 255, 0.5)",
              "rgba(255, 159, 64, 0.5)",
              "rgba(201, 203, 207, 0.5)",]

const labels = ["January", "February", "March", "April", "May", "June", "July"];

export const data = {
  labels,
  datasets: [
    {
      label: "SA",
      data: labels.map(() => Math.random(1, 100)),
      borderColor: "rgb(255, 99, 132)",
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: "NSW",
      data: labels.map(() => Math.random(1, 100)),
      borderColor: "rgb(53, 162, 235)",
      backgroundColor: "rgba(53, 162, 235, 0.5)",
    },
    {
      label: "VIC",
      data: labels.map(() => Math.random(1, 100)),
      borderColor: "rgba(75, 192, 192, 1)",
      backgroundColor: "rgba(75, 192, 192, 0.2)",
    },
    {
      label: "WA",
      data: labels.map(() => Math.random(1, 100)),
      borderColor: "red",
      backgroundColor: "rgba(255, 99, 132, 0.5)",
    },
    {
      label: "QLD",
      data: labels.map(() => Math.random(1, 100)),
      borderColor: "purple",
      backgroundColor: "rgba(16, 28, 0, 0)",
    },
  ],
};

const StatisticsLineChart = () => {
  return <Line options={options} data={data} />;
};

export function bookingLineChart(input){
  const months = Object.keys(input)
  const innerKeysSet = new Set();
  for (const month in input) {
    const innerKeys = Object.keys(input[month]);
    innerKeys.forEach((key) => {
      if(key != 'All'){innerKeysSet.add(key);}
    });
  }
  const labels = Array.from(innerKeysSet);
  let dataset = []
  let n = 0
  
    for(let state of labels){
      let dataArr = []
      for(let month of months){
        if(input[month][state]){
          dataArr.push(input[month][state])
        }else{
          dataArr.push(0)
        }
      }
      
      dataset.push({
        label: state,
        data: dataArr,
        borderColor: bgColor[n],
        backgroundColor: bgColor[n],
      })
      n++
    }
  const chartData = {
    labels : months,
    datasets: dataset
  }
  return <Line options={options} data={chartData} />;
}

export default StatisticsLineChart;
